import { __makeTemplateObject } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { fontStack } from '../../utils/fontStack';
export var TabPanels = styled(function (_a) {
    var active = _a.active, groupId = _a.groupId, className = _a.className, shouldRenderOnlyActive = _a.shouldRenderOnlyActive, children = _a.children;
    return (React.createElement("div", { className: className }, React.Children.map(children, function (child, index) {
        var element = child;
        if (React.isValidElement(element)) {
            var isNumber = Number.isInteger(active);
            var ident = element.props.name ? element.props.name : index;
            element = React.cloneElement(element, {
                isActive: isNumber
                    ? active === index
                    : active === element.props.name,
                id: groupId + "-panel-" + ident,
                'aria-labelledby': groupId + "-tab-" + ident,
                shouldRenderOnlyActive: shouldRenderOnlyActive,
            });
        }
        return element;
    })));
})(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), fontStack); });
TabPanels.propTypes = {
    groupId: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    shouldRenderOnlyActive: PropTypes.bool,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=TabPanels.js.map